import {
  makeStyles,
  Typography,
  Button,
  Breadcrumbs,
  Link as MuiLink,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { Fragment } from "react";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import FilterElement from "./commonComponents/Filter";
import SortElement from "./commonComponents/Sort";
import SettingsIcon from "../common/components/CreateDataTable/icons/SettingsIcon";
import EditIcon from "./PortalAppLayout/components/icons/EditIcon";
import { Link } from "react-router-dom";
import {
  editorNavigationUrls,
  otherProtectedUrls,
  portalNavigationUrls,
  unprotectedUrls,
} from "../common/utils/lists";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import { useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { AdminPlugAdminPermissions } from "../common/utils/userRoleEvaluation";

export const useStyles = makeStyles((theme) => {
  return {
    item: {
      cursor: "pointer",
      "&:hover": {
        background: "#DE54391F",
      },
    },
    pageTitle: {
      fontSize: "22px",
      marginBottom: "16px",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    pageTitleOptions: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },

    pageSubtitle: {
      fontSize: "16px",
      width: "100%",
      alignItems: "center",
      gap: "20px",
      justifyContent: "space-between",

      [theme.breakpoints.up(1140)]: {
        display: "flex",
      },
    },

    pageSubtitleOptions: {
      display: "flex",
      gap: "25px",
      alignItems: "center",
    },

    pageSubtitleOptionsContainer: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      background: "#F8F8F8",
      borderRadius: "8px",
      padding: "5px",
      color: "#FFFFFF",
    },

    container: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#FFFFFF",
      padding: "24px",
      borderRadius: "8px",
    },
    headerTitle: {
      cursor: "pointer",
    },
    breadcrumb: {
      color: "#ABABAB",
    },
    breadcrumbContainer: {
      display: "flex",
      alignItems: "center",
      paddingBottom: "16px",
    },
    activeBreadcrumbLink: {
      textDecoration: "underline",
      color: "#535353",
    },
    separator: {
      margin: 0,
    },
    button: {
      background: "#F0F0F0",
      color: "#535353",
      textTransform: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "Avenir,Inter",
      padding: "4px 16px",
    },
    createNewButton: {
      background: "#292929",
      color: "#FFFFFF",
      textTransform: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "Avenir,Inter",
      padding: "5px 24px",
    },
    menuItemText: {
      background: "#292929",
      color: "#FFFFFF",
      textTransform: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: 400,
      fontFamily: "Avenir,Inter",
      padding: "6px",
    },
    menuPaper: {
      background: "#FFFFFF",
      padding: "8px 0px",
      borderRadius: "16px",
      fontWeight: 400,
      color: "#535353",
      width: "160px",
    },
    IconButton: {
      background: "#F0F0F0",
      color: "#535353",
      borderRadius: "8px",
      padding: "9px",
    },
  };
});

const MainPortalLayout = (props) => {
  const {
    pageTitle,
    sortFunc,
    filterFunc,
    sortItems,
    filterItems,
    pageSubtitle,
    children,
    isLoading = false,
    showBreadCrumb = false,
    showPageTitleOptionButtons = false,
    showPageSubtitleOptionButtons = false,
    appSummary = {},
    setAppSummary = () => {},
    handleUpdate = () => {},
    userRole = [],
  } = props;

  const isAdminPlugAdminRole = AdminPlugAdminPermissions(userRole);

  const appProcessSummaryMenuItemOptions = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Created by me",
      value: "own",
    },
    {
      label: "Assigned to  me",
      value: "directreport",
    },
    // { label: "Draft", value: "draft" },
  ];

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMenuItemOption, setSelectedMenuItemOption] = useState(
    isAdminPlugAdminRole
      ? appProcessSummaryMenuItemOptions[0]
      : appProcessSummaryMenuItemOptions[1]
  );
  const showSettings = false;

  const handleMenuClick = (event) => {
    setAnchorEl(event.target);
  };

  const handleMenuItemOptionClick = (event, option) => {
    setSelectedMenuItemOption(option);
    setAnchorEl(null);

    handleUpdate({
      appTaskLevel: option?.value,
    });
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={`${classes.container} portal-main-layout`}>
      {/* Render the breadcrumb */}
      {showBreadCrumb && (
        <>
          {isLoading ? (
            <Fragment>
              <Skeleton variant="text" width={80} height={25} />
            </Fragment>
          ) : (
            <div className={classes.breadcrumbContainer}>
              <Link
                to={`${portalNavigationUrls.APPS}`}
                onClick={() => {
                  setAppSummary({});
                }}
              >
                <IconButton size="small" aria-label="Go back">
                  <ArrowBackIosRoundedIcon fontSize="small" />
                </IconButton>
              </Link>

              <Breadcrumbs
                aria-label="breadcrumb"
                classes={{
                  root: classes.breadcrumb,
                  separator: classes.separator,
                }}
              >
                <MuiLink color="inherit">Apps</MuiLink>
                <MuiLink
                  color="inherit"
                  classes={{ root: classes.activeBreadcrumbLink }}
                >
                  {appSummary?.name}
                </MuiLink>
                <Typography
                  color="textPrimary"
                  classes={{ root: classes.activeBreadcrumbLink }}
                >
                  {selectedMenuItemOption?.label}
                </Typography>
              </Breadcrumbs>
            </div>
          )}
        </>
      )}

      {/* Render the pageTitle and Subtitle along with the options if any */}
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "2rem",
          }}
        >
          {isLoading ? (
            <Fragment>
              <Skeleton variant="text" width={100} height={45} />
              <Skeleton variant="text" width={250} height={35} />
            </Fragment>
          ) : (
            <Fragment>
              <Typography
                classes={{ root: classes.pageTitle }}
                noWrap
                component="div"
              >
                {pageTitle}

                {showPageTitleOptionButtons && (
                  <div className={classes.pageTitleOptions}>
                    <Link
                      to={`${otherProtectedUrls.EDITOR}/${appSummary?._id}${editorNavigationUrls.UI_EDITOR}`}
                    >
                      <Button
                        variant="contained"
                        className={classes.button}
                        endIcon={<EditIcon />}
                        disableElevation
                        fullWidth
                      >
                        Edit
                      </Button>
                    </Link>

                    {showSettings && (
                      <IconButton
                        className={classes.IconButton}
                        size="large"
                        aria-label="Go-to-Settings"
                      >
                        <SettingsIcon />
                      </IconButton>
                    )}
                  </div>
                )}
              </Typography>
              <Typography
                classes={{ root: classes.pageSubtitle }}
                component="div"
              >
                {pageSubtitle}

                <div className={classes.pageSubtitleOptions}>
                  {showPageSubtitleOptionButtons && (
                    <Fragment>
                      <div className={classes.pageSubtitleOptionsContainer}>
                        <Typography
                          className={classes.menuItemText}
                          style={{ color: "#FFFFFF" }}
                        >
                          {selectedMenuItemOption?.label}
                        </Typography>
                        <IconButton
                          size="small"
                          edge="end"
                          aria-haspopup="true"
                          onClick={handleMenuClick}
                        >
                          <KeyboardArrowDownRoundedIcon fontSize="large" />
                        </IconButton>

                        <Menu
                          id="subtitle-app-process-summary-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                          classes={{ paper: classes.menuPaper }}
                        >
                          {appProcessSummaryMenuItemOptions
                            ?.filter((admin) => {
                              const isAdminOption = isAdminPlugAdminRole
                                ? admin.label
                                : admin.label !== "All";

                              return isAdminOption;
                            })
                            ?.map((option, index) => (
                              <MenuItem
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "Avenir,Inter",
                                }}
                                key={index}
                                selected={
                                  option?.label === selectedMenuItemOption
                                }
                                onClick={(event) =>
                                  handleMenuItemOptionClick(event, option)
                                }
                              >
                                {option?.label}
                              </MenuItem>
                            ))}
                        </Menu>
                      </div>
                      <Link
                        to={`${unprotectedUrls.RUN}/${appSummary?.account?.slug}/${appSummary?.slug}`}
                        target="_blank"
                      >
                        <Button
                          variant="contained"
                          className={classes.createNewButton}
                          disableElevation
                        >
                          Create new
                        </Button>
                      </Link>
                    </Fragment>
                  )}
                  {!!filterItems && (
                    <FilterElement
                      filterFunc={filterFunc}
                      classes={classes}
                      itemArr={filterItems}
                    />
                  )}

                  {!!sortItems && (
                    <SortElement
                      sortFunc={sortFunc}
                      classes={classes}
                      itemArr={sortItems}
                    />
                  )}
                </div>
              </Typography>
            </Fragment>
          )}
        </div>
      </div>

      {/* Render the children component */}
      <div>{children}</div>
    </div>
  );
};
export default MainPortalLayout;
